import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';

import { mediaQueryKeys } from 'utility';
import { useBreakpoint } from 'components/shared/context/breakpoint_provider';
import { RootReducerState } from 'redux/reducers';
import { MobileHeader } from './mobile_header';
import { DesktopHeader } from './desktop_header';

export const HeaderComponent = withRouter(() => {
  const breakpoints = useBreakpoint();
  const authenticated = useSelector((state: RootReducerState) => state.security.authenticated);
  const user = useSelector((state: RootReducerState) => state.security.user);
  const history = useHistory();

  return breakpoints[mediaQueryKeys.mobile] ? (
    <MobileHeader authenticated={authenticated} user={user} />
  ) : (
    <DesktopHeader authenticated={authenticated} user={user} history={history} />
  );
});
